import { Box, Typography } from '@mui/material';
import React from 'react';
import propTypes from 'prop-types';

function Text(props) {
  const { configuration, propName } = props;

  return (
    <Box pb={4}>
      {configuration &&
        configuration[propName]?.split('\n').map((line, index) => {
          return line ? (
            <Typography key={index}>
              {line.split('*').map((e, index2) => {
                return index2 % 2 === 0 ? <span>{e}</span> : <b>{e}</b>;
              })}
            </Typography>
          ) : (
            <br />
          );
        })}
    </Box>
  );
}

const Props = {
  configuration: propTypes.object,
  propName: propTypes.string,
};

Text.propTypes = Props;

export default Text;
